import { useQuery } from "@tanstack/react-query";
import { rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/**
 * Nombres de TODOS los roles (sistema + personalizados) que pueden asignarse como
 * autorizadores de un nivel · se traen del backend (`/admin/roles`). Reemplaza la
 * lista HARDCODED `ROLES_AUTORIZADORES` — así los roles personalizados (RBAC · P46)
 * también se pueden usar como autorizadores.
 */
export function useRolesAsignables(): string[] {
  const { data } = useQuery(rolesAdminQueryOptions);
  return (data ?? []).map((r) => r.nombre);
}
